import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL + 'api/public/';
export const IMG_URL = process.env.REACT_APP_IMG_URL + 'uploads/artbanne/';

const TENANT = 'artbanne';

const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        'x-tenant': TENANT
    }
});

let storedStayDatas = {
    nbPersons: undefined,
    stayDates: {
        startDate: undefined,
        endDate: undefined
    }
};

let storedBlockedDates = [];
let dataLoaded = false;

export const Api = {
    saveStayDatas: function (data) {
        storedStayDatas = data;
    },

    getStayDatas: function () {
        return storedStayDatas;
    },

    storeBlockedDates: function (data) {
        storedBlockedDates = data;
        dataLoaded = true;
    },

    getBlockedDatesStored: function () {
        return storedBlockedDates;
    },

    isDataLoaded: function () {
        return dataLoaded;
    },

    getBlockedDates: async function () {
        try {
            return await apiClient.get('calendar/blockedDates');
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    sendEventContact: async function (payload) {
        try {
            return await apiClient.post('events/contact', payload);
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    sendMessageContact: async function (data) {
        try {
            return await apiClient.post('contact/', { data });
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    sendMessageContactCommercial: async function (data) {
        try {
            return await apiClient.post('contact/commercial', { data });
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getPrices: async function () {
        try {
            return await apiClient.get('prices/');
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getPricesForDates: async function (startDate, endDate, accommodation) {
        try {
            return await apiClient.post('quotation/getPricesForDates', { startDate, endDate, accommodation });
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getServicesForReservation: async function () {
        try {
            return await apiClient.get('service/getServicesForReservation');
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getAllServices: async function () {
        try {
            return await apiClient.get('service/getAllServices');
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getMinimumStayRules: async function () {
        try {
            return await apiClient.get('calendar/minimumStayRules');
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getQuotation: async function (id) {
        try {
            return await apiClient.get('quotation/getQuotation/' + id);
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getQuotationGroup: async function (id) {
        try {
            return await apiClient.get('quotation-group/getQuotationGroup/' + id);
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getQuotationsByIds: async function (ids) {
        try {
            return await apiClient.post('quotation-group/bulk/', { ids });
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    sendQuotation: async function (quotation) {
        try {
            return await apiClient.post('quotation/sendQuotation/', { quotation });
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getPDFQuotation: async function (quotation) {
        try {
            return await apiClient.get('quotation/getPDFQuotationWithCGV/' + quotation._id, {
                responseType: 'blob',
                timeout: 30000
            });
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getPDFQuotationCGV: async function (quotation) {
        try {
            return await apiClient.get('quotation/getPDFQuotationCGV/' + quotation._id, {
                responseType: 'blob',
                timeout: 30000
            });
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    visualizeQuotation: async function (quotation) {
        try {
            const response = await this.getPDFQuotation(quotation);
            const fileURL = window.URL.createObjectURL(response.data);
            window.open(fileURL);
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    downloadQuotation: async function (quotation) {
        try {
            const response = await this.getPDFQuotation(quotation);
            this.downloadBlob(response.data, 'Devis.pdf');
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    downloadQuotationCGV: async function (quotation) {
        try {
            const response = await this.getPDFQuotationCGV(quotation);
            this.downloadBlob(response.data, 'CGV.pdf');
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    downloadBlob: function (blob, fileName) {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    },

    changeStatusQuotation: async function (quotationID, status) {
        try {
            return await apiClient.post('quotation/changeStatusQuotation/', { quotationID, status });
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    changeStatusQuotationGroup: async function (id, status) {
        try {
            return await apiClient.post('quotation-group/status/', { id, status });
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    sendChangeRequest: async function (quotationID, changeRequest) {
        try {
            return await apiClient.post('quotation/sendChangeRequest/', { quotationID, changeRequest });
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    saveQuotation: async function (quotation) {
        try {
            return await apiClient.post('quotation/saveQuotation/', { quotation });
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getTestimonials: async function (lang) {
        try {
            return await apiClient.get('testimonials', {
                params: { lang }
            });
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getDayOverrides: async function (from, to, accommodation, grouped = false) {
        const toISODate = (d) => {
            if (!d) return undefined;
            if (typeof d === 'string') return d;
            const dt = new Date(d);
            return Number.isNaN(dt.valueOf()) ? undefined : dt.toISOString().slice(0, 10);
        };

        try {
            const params = {
                from: toISODate(from),
                to: toISODate(to),
                accommodation,
                grouped
            };

            Object.keys(params).forEach((key) => params[key] === undefined && delete params[key]);

            return await apiClient.get('calendar/different-prices', { params });
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getAnnouncementConfig: async function () {
        try {
            return await apiClient.get('announcement/');
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getPublicEvents: async function () {
        try {
            return await apiClient.get('events/');
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getPublicEvent: async function (slug) {
        try {
            return await apiClient.get('events/' + slug);
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    getBusinessProposal: async function (id) {
        try {
            return await apiClient.get('business-proposal/' + id);
        } catch (error) {
            console.log(error);
            return error;
        }
    },

    acceptBusinessProposal: async function (proposalId, quotation) {
        try {
            return await apiClient.post('business-proposal/' + proposalId, { quotation });
        } catch (error) {
            console.log(error);
            return error;
        }
    }
};

export default Api;